import React from 'react';
import './Headercdq.css';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'; // Import de l'icône de flèche

const Headercdq = () => {
    return (
        <div className='mairie1c'>
            
            <div className="boutton-containerc">
                <div className='butc'>
             <button className="bouttonc">ACCUEIL<ArrowForwardIcon className="arrow-icon" />CHEFS DE QUARTIER ET CDQ</button>
             <h1>CHEFS DE QUARTIER ET CDQ</h1> 
            </div>
            </div>
        </div>
    );
};

export default Headercdq;
